// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YBqW","label":"styles_label__32Yzr"};